import { Controller } from 'react-hook-form';
import type { Control } from 'react-hook-form';
import Input from 'src/components/Input/Input';
import { ZENDESK_HELP_CENTER_URL } from 'src/constants/urls';
import type { ZendeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/zendeskHelpCenterFormValues';

// The email and API key for connecting to Zendesk manually.
export const ZendeskHelpCenterCredentialFields = ({
  control,
}: {
  control: Control<ZendeskHelpCenterFormValues>;
}) => (
  <>
    <Controller
      control={control}
      name="zendesk_email"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Input
          type={'email'}
          label={'Zendesk email'}
          placeholder={'email@zendesk.com'}
          invalidMessage={error?.message}
          value={value}
          isValid={!error?.message}
          onChange={onChange}
          infoTooltip={{
            side: 'right',
            description: <>Email address of the Zendesk user used to generate the API key</>,
          }}
        />
      )}
    />
    <Controller
      control={control}
      name="zendesk_api_key"
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Input
          type={'password'}
          label={'Zendesk API key'}
          placeholder={'------------------------------------------------------'}
          invalidMessage={error?.message}
          value={value}
          isValid={!error?.message}
          onChange={onChange}
          infoTooltip={{
            side: 'right',
            description: (
              <>
                Check how to generate the API Key{' '}
                <a
                  href={ZENDESK_HELP_CENTER_URL.API_KEY}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline cursor-pointer"
                >
                  here →
                </a>
              </>
            ),
          }}
        />
      )}
    />
  </>
);
